import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  // 注意：不启用 StrictMode —— react-hot-toast 2.6.0 在 React 19 StrictMode
  // 双渲染下会触发 "Failed to execute 'removeChild'" 崩溃（已知兼容 bug）
  <App />
);

// bfcache（页面往返缓存）防护：浏览器从 bfcache 恢复页面时，旧 DOM 状态与
// React 新挂载失步，会导致 "Failed to execute 'insertBefore'" 崩溃。
// 检测到 bfcache 恢复（event.persisted=true）时强制整页刷新，重建干净 DOM。
window.addEventListener('pageshow', (event) => {
  if (event.persisted) {
    window.location.reload();
  }
});

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
